import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getCollaborators = store => store[NAME].collaborators;
export const getRegularCertificates = store => store[NAME].regularCertificates;
export const getCertificatesWithSign = store => store[NAME].certificatesWithSign;
export const getReceiverList = store => store[NAME].receiverList;
export const getLocale = store => store[NAME].locale;
export const getDateFormat = store => store[NAME].dateFormat;